"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.BASEURL = exports.Token = void 0;

export const BASEURL = process.env.VUE_APP_BASEURL;
export const SOCKETURL = process.env.VUE_APP_SOCKETURL;
export const IMGBASEURL = process.env.VUE_APP_IMGBASEURL;
export const Token = process.env.VUE_APP_TOKEN;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;

// exports.Token = Token;
// var BASEURL = Livebaseurl;
// exports.BASEURL = BASEURL;



// WEBPACK FOOTER //
// ./src/config/index.js